<div class="mc-devices-menu">
  <div class="header">
    <div class="header-content">
      <span>{{ 'ssp_label_MyDevices' | xsI18n }}</span>
    </div>
  </div>
  <ul class="devices-list list-unstyled">
    <li
      class="device-item"
      *ngFor="let device of deviceContextService.devicesSsp"
      (click)="onDeviceClick(device)"
      [ngClass]="{ active: device.deviceId == id}"
    >
      <span class="selector"></span>

      <sa-device-icon [form]="device.form" [complianceStatus]="device.complianceStatus"></sa-device-icon>

      <span class="cont-main">
        <ul class="list-unstyled">
          <li class="info-name" sa-ellipsis-text one-time="false" full-text="device.deviceName">
            {{ device.deviceName }}
          </li>
          <li class="info-sub1">
            <ul class="list-unstyled">
              <li class="info-icon" [ngClass]="device.Family">
                <i class="fa fa-fw fa-apple"></i>
                <i class="fa fa-fw fa-android"></i>
                <i class="fa fa-fw fa-windows"></i>
                {{ device.system }}
              </li>
              <li *ngIf="!!device.telno"><i class="fa fa-fw fa-phone"></i> {{ device.telno }}</li>
            </ul>
          </li>
          <li class="info-sub2">
            <ul class="list-unstyled">
              <!-- <li *ngIf="!!device.SerialNumber">
                <span>{{ 'label_SerialNumber' | xsI18n }}</span
                >: {{ device.SerialNumber }}
              </li> -->
              <li *ngIf="!!device.BatteryStatus">
                <span>{{ 'label_Battery' | xsI18n }}</span
                >: {{ device.BatteryStatus }}%
              </li>
            </ul>
          </li>
        </ul>
      </span>
      <mc-actions-menu [device]="device"></mc-actions-menu>
    </li>
  </ul>
  <div class="add-btn-panel">
    <a [routerLink]="['/enroll']" class="create-btn">
      <div class="hd-icon hd-icon-addnew"></div>
      <div class="add-label">
        {{ 'label_AddDevice' | xsI18n }}
      </div>
    </a>
  </div>
  <!-- <sa-ticket-card-list *ngIf="ui.canViewTickets()"></sa-ticket-card-list> -->
</div>
